import React, { useEffect, useState } from "react";
import { Modal, Calendar, Input, Button, Typography, Row, Col, Alert } from "antd";
import dayjs from "dayjs";
import "./markAttendanceModal.css";

const { Text } = Typography;

const MarkAttendanceModal = ({
  visible,
  onClose,
  onMarkAttendance,
  checkInTime,
  checkOutTime,
  updateCalendar,
  isDisabled,
  statusLoading,
  userDistance,
  existingShortLeave,
}) => {
  const [dateTime, setDateTime] = useState(dayjs());
  const [notes, setNotes] = useState("");

  // 🕒 Live date/time
  useEffect(() => {
    const timer = setInterval(() => setDateTime(dayjs()), 1000);
    return () => clearInterval(timer);
  }, []);

  // 🧹 Reset when closed
  useEffect(() => {
    if (!visible) {
      setNotes("");
    }
    
  }, [visible]);
  

  const disableAllDates = () => true;  

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
      // bodyStyle={{
      //   maxHeight: "70vh",
      //   overflowY: "auto",
      //   scrollbarWidth: "none", // hide scrollbar (Firefox)
      //   msOverflowStyle: "none",
      // }}
      className="attendance-modal"
    >
      {/* Header with Title + Time */}
      <Row justify="space-between" align="middle" style={{ marginTop: "1rem" }}>
        <Col>
          <Text strong className="attendance-modal-title">
            Mark your Attendance
          </Text>
        </Col>
        <Col style={{ display: "flex", gap: "1rem" }}>
          <Text className="attendance-modal-time">
            {dateTime.format("DD-MMM-YYYY hh:mm:ss A")}
          </Text>
          {/* <Text className="attendance-modal-time">
            <span style={{ color: "green" }}>
              You are {userDistance ? userDistance.toFixed(2) : "0.00"} meters
              away
            </span>
          </Text> */}
        </Col>
      </Row>

      {/* Calendar */}
      <div className="attendanceOverview-calendar-container mark-attendance-calendar-container" style={{ marginTop: "2rem" }}>
        <Calendar
          fullscreen={false}
          onChange={updateCalendar}
          disabledDate={disableAllDates}
        />
      </div>

      {existingShortLeave && (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 16 }}
          message="Short Leave Exists"
          description={
            existingShortLeave.leave_portion ===
            "first_half"
              ? "First-half leave already applied."
              : "Second-half leave already applied."
          }
        />
      )}

      {/* Notes Input */}
      <div style={{ marginTop: "2rem" }}>
        <label className="form-label">Notes</label>
        <Input
          placeholder="Notes"
          value={notes}
          onChange={(e) => {
            const val = e.target.value;
            if (val.length <= 50) setNotes(val);
          }}
          onKeyDown={(e) => {
            if (
              notes &&
              notes.toString().length >= 50 &&
              !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                e.key
              )
            ) {
              e.preventDefault();
            }
          }}
        />
        <Text type="secondary" style={{ fontSize: 12 }}>
          {notes.length}/50 characters
        </Text>
      </div>

      {/* Check In / Out Display */}
      <div className="check-container">
        <div>
          <span>Check In:</span>{" "}
          <span style={{ color: "green" }}>{checkInTime || "--"}</span>
        </div>
        <div>
          <span>Check Out:</span>{" "}
          <span style={{ color: "red" }}>{checkOutTime || "--"}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="attendance-buttons">
        <Button onClick={onClose}>Discard</Button>
        <Button
          type="primary"
          loading={statusLoading}
          disabled={
            isDisabled || statusLoading || (checkInTime && checkOutTime) // Disable if both exist, or status not loaded yet
          }
          onClick={() =>
            onMarkAttendance({
              notes,
              date: dateTime.format("YYYY-MM-DD"),
              time: dateTime.format("HH:mm:ss"),
            })
          }
        >
          {statusLoading
            ? "Checking status..."
            : !checkInTime
            ? "Check In"
            : checkInTime && !checkOutTime
            ? "Check Out"
            : "Marked"}
        </Button>
      </div>
    </Modal>
  );
};

export default MarkAttendanceModal;
